import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import LoadingScreen from 'src/components/LoadingScreen';
import DemandController from '../../controllers/Demands/DemandController';
import { AutoComplete, AutoCompleteCompleteMethodParams } from 'primereact/autocomplete';
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber';
import { ModelOfDriver, ModelOfMotoristaVeiculo } from 'src/database';
import { Button } from 'primereact/button';
import classNames from 'classnames';

interface filteredProps {
    label: string;
    value?: string;
}
type Veiculo = {
    value: string | undefined;
    label: string;
}
type Creditor = {
    value: string | undefined;
    label: string;
}

type Motorista = {
    value: string | undefined;
    label: string;
}

const AbastecimentoForm: React.FC = () => {
    const { getDemandData, dataResponse } = DemandController();
    const { formikCombustivel, toast, unitys, prioritys, vehicles, creditors, motoristas, managers, stocks,
        fuels, getDrivers, getFuelVeiculotypes, getValorCombustivel, response } = getDemandData;
    const [valueVehicle, setValueVehicle] = useState('');
    const [valueCreditors, setValueCreditors] = useState('');
    const [valueMotorista, setValueMotorista] = useState('');
    const [filteredVehicle, setFilteredVehicle] = useState<filteredProps[]>([{ label: '', value: '' }]);
    const [valueData, setValueData] = useState('');
    const [valueDataFim, setValueDataFim] = useState('');
    const [valueValorCombustivel, setValueValorCombustivel] = useState<number | undefined>(0)
    const [valueFuel, setValueFuel] = useState('');
    const [filteredFuels, setFilteredFuels] = useState<filteredProps[]>([{ label: '', value: '' }]);
    const [valueQuantidadeCombustivel, setValueQuantidadeCombustivel] = useState<number | undefined>(0)
    const [registerFinished, setRegisterFinished] = useState(false);
    const [valueStock, setValueStock] = useState('');
    const [filteredStocks, setFilteredStocks] = useState<filteredProps[]>([{ label: '', value: '' }]);
    ///// VEICULO
    const [selectedVeiculo, setSelectedVeiculo] = useState<Veiculo | null>(null);
    const [filteredVeiculo, setFilteredVeiculo] = useState<Veiculo[]>([]);
    const veiculos: Veiculo[] = [...vehicles];
    const searchVeiculo = (event: AutoCompleteCompleteMethodParams) => {
        const query = event.query.toLowerCase();
        const results = veiculos.filter(veiculo =>
            veiculo.label.toLowerCase().includes(query)
        );
        setFilteredVeiculo(results);
    };
    /////
    ///// CREDOR
    const [selectedCreditors, setSelectedCreditors] = useState<Creditor | null>(null);
    const [filteredCreditor, setFilteredCreditor] = useState<Creditor[]>([]);
    const fornecedores: Creditor[] = [...creditors];
    
    
    const searchCreditor = (event: AutoCompleteCompleteMethodParams) => {
        const query = event.query.toLowerCase();
        const results = fornecedores.filter(fornecedor =>
            fornecedor.label.toLowerCase().includes(query)
        );
        setFilteredCreditor(results);
    };
    /////
    ///// MOTORISTAVEICULO
    const [selectedMotorista, setSelectedMotorista] = useState<Motorista | null>(null);
    const [filteredMotorista, setFilteredMotorista] = useState<Motorista[]>([]);
    const motoristass: Motorista[] = [...motoristas];
    const searchMotorista = (event: AutoCompleteCompleteMethodParams) => {
        const query = event.query.toLowerCase();
        const results = motoristass.filter(motorista =>
            motorista.label.toLowerCase().includes(query)
        );
        setFilteredMotorista(results);
    };
    /////
    ////ESTOQUE ///
    const searchStocks = (event: any) => {
        let filteredStocks;
        if (!event.query.trim().length) {
            filteredStocks = [...stocks];
        } else {
            filteredStocks = managers.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredStocks(filteredStocks);
    };
    //TIPO COMBUSTIVEL//
    const searchFuels = (event: any) => {
        let filteredFuels;
        if (!event.query.trim().length) {
            filteredFuels = [...fuels];
        } else {
            filteredFuels = fuels.filter(unity => {
                return unity.label.toLowerCase().includes(event.query.toLowerCase());
            });
        }
        setFilteredFuels(filteredFuels);
    };

    useEffect(() => {
        if (dataResponse.response?.status === 200) {
            setRegisterFinished(true);
        }
        if (dataResponse.response?.status !== 200) {
            setRegisterFinished(false);
        }
    }, [dataResponse.response]);

    return (
        <div>
            <Toast ref={toast} />

            <div style={{ height: '100%' }} className='card p-align-center p-justify-center'>
                <h5>Abastecimento</h5>
                <div className='p-grid p-fluid'>
                    <div className='p-field p-col-12 p-md-4'>
                        <label htmlFor='descricao'>Veículo</label>
                        <AutoComplete
                            id="vehicle"
                            value={selectedVeiculo}
                            suggestions={filteredVeiculo}
                            completeMethod={searchVeiculo}
                            onSelect={e => {
                                setValueVehicle(e.value.label);
                                formikCombustivel.setFieldValue('FT_VEICULO', e.value.value);
                                getDrivers(e.value.value)
                                getFuelVeiculotypes(e.value.value)
                            }}
                            field="label"
                            dropdown
                            onChange={(e) => {
                                setSelectedVeiculo(e.value)
                                formikCombustivel.setFieldValue(
                                    'FT_VEICULO',
                                    filteredVehicle.find(vehicle => {
                                        return e.value === vehicle.label;
                                    })?.value || '',
                                );
                            }}
                            placeholder="Selecione a Veículo..."
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    formikCombustivel.touched.FT_VEICULO && formikCombustivel.errors.FT_VEICULO,
                                'popup-form-inactive': !(
                                    formikCombustivel.touched.FT_VEICULO && formikCombustivel.errors.FT_VEICULO
                                ),
                            })}>
                            {formikCombustivel.errors.FT_VEICULO}
                        </div>

                    </div>

                    <div className='p-field p-col-12 p-md-4'>
                        <label htmlFor='descricao'>Motorista</label>
                        <AutoComplete
                            id="vehicle"
                            value={selectedMotorista}
                            suggestions={filteredMotorista}
                            completeMethod={searchMotorista}
                            onSelect={e => {
                                setValueMotorista(e.value.NOME);
                                formikCombustivel.setFieldValue('FT_MOTORISTA', e.value.value);

                            }}
                            field="label"
                            dropdown
                            onChange={(e) => {
                                setSelectedMotorista(e.value)
                                formikCombustivel.setFieldValue(
                                    'FT_MOTORISTA',
                                    filteredMotorista.find(motorista => {
                                        return e.value === motorista.label;
                                    })?.label || '',
                                );
                            }}
                            placeholder="Selecione o motorista..."
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    formikCombustivel.touched.FT_MOTORISTA && formikCombustivel.errors.FT_MOTORISTA,
                                'popup-form-inactive': !(
                                    formikCombustivel.touched.FT_MOTORISTA && formikCombustivel.errors.FT_MOTORISTA
                                ),
                            })}>
                            {formikCombustivel.errors.FT_MOTORISTA}
                        </div>

                    </div>

                    <div className='p-field p-col-12 p-md-4'>
                        <label htmlFor='descricao'>Posto</label>
                        <AutoComplete
                            id="vehicle"
                            value={selectedCreditors}
                            suggestions={filteredCreditor}
                            completeMethod={searchCreditor}
                            onSelect={e => {
                                setValueCreditors(e.value.label);
                                formikCombustivel.setFieldValue('CREDOR', e.value.value);
                            }}
                            field="label"
                            dropdown
                            onChange={(e) => {
                                setSelectedCreditors(e.value)
                                formikCombustivel.setFieldValue(
                                    'CREDOR',
                                    filteredCreditor.find(creditor => {
                                        return e.value === creditor.label;
                                    })?.value || '',
                                );
                            }}
                            placeholder="Selecione o posto..."
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    formikCombustivel.touched.CREDOR && formikCombustivel.errors.CREDOR,
                                'popup-form-inactive': !(
                                    formikCombustivel.touched.CREDOR && formikCombustivel.errors.CREDOR
                                ),
                            })}>
                            {formikCombustivel.errors.CREDOR}
                        </div>

                    </div>
                    <div className='p-field p-col-12 p-md-4'>
                        <label htmlFor='estoque'>Estoque</label>
                        <div className='p-inputgroup'>
                            <AutoComplete
                                id='estoque'
                                dropdown
                                placeholder='Selecione o estoque...'
                                value={valueStock}
                                onChange={e => {
                                    setValueStock(e.value.label);
                                    formikCombustivel.setFieldValue(
                                        'FT_ESTOQUE',
                                        filteredStocks.find(stock => {
                                            return e.value === stock.label;
                                        })?.value || '',
                                    );
                                }}
                                onSelect={e => {
                                    setValueStock(e.value.label);
                                    formikCombustivel.setFieldValue('FT_ESTOQUE', e.value.value);
                                }}
                                suggestions={filteredStocks}
                                field='label'
                                completeMethod={searchStocks}
                            />
                            <div
                                className={classNames('p-invalid popup-fade', {
                                    'popup-form-active':
                                        formikCombustivel.touched.FT_ESTOQUE && formikCombustivel.errors.FT_ESTOQUE,
                                    'popup-form-inactive': !(
                                        formikCombustivel.touched.FT_ESTOQUE && formikCombustivel.errors.FT_ESTOQUE
                                    ),
                                })}>
                                {formikCombustivel.errors.FT_ESTOQUE}
                            </div>
                        </div>
                    </div>

                    <div className='p-field p-col-12 p-md-2'>
                        <label htmlFor='descricao'>Data Inicio</label>
                        <InputMask
                            type={'text'}
                            mask='99/99/9999'
                            value={valueData}
                            onChange={e => {
                                setValueData(e.target.value);
                                formikCombustivel.setFieldValue('DATA', e.target.value);
                            }}
                            placeholder='__/__/____'
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    formikCombustivel.touched.DATA && formikCombustivel.errors.DATA,
                                'popup-form-inactive': !(
                                    formikCombustivel.touched.DATA && formikCombustivel.errors.DATA
                                ),
                            })}>
                            {formikCombustivel.errors.DATA}
                        </div>
                    </div>

                    <div className='p-field p-col-12 p-md-2'>
                        <label htmlFor='descricao'>Data Fim</label>
                        <InputMask
                            type={'text'}
                            mask='99/99/9999'
                            value={valueDataFim}
                            onChange={e => {
                                setValueDataFim(e.target.value);
                                formikCombustivel.setFieldValue('DATAFIM', e.target.value);
                            }}
                            onFocus={e => {
                                console.log("Data Fim: ",e.target.value)
                                if (!valueDataFim) {  
                                    console.log("entrou Data Fim: ",e.target.value)
                                    setValueDataFim(valueData);
                                    formikCombustivel.setFieldValue('DATAFIM', valueData);
                                }
                            }}
                            placeholder='__/__/____'
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    formikCombustivel.touched.DATAFIM && formikCombustivel.errors.DATAFIM,
                                'popup-form-inactive': !(
                                    formikCombustivel.touched.DATAFIM && formikCombustivel.errors.DATAFIM
                                ),
                            })}>
                            {formikCombustivel.errors.DATAFIM}
                        </div>
                    </div>


                    <div className='p-field p-col-4 p-md-4'>
                        <label htmlFor='descricao'>Tipo de Combustível</label>
                        <AutoComplete
                            id='COMBUSTIVEL'
                            value={valueFuel}
                            field='label'
                            onChange={e => {
                                setValueFuel(e.value.label);
                                formikCombustivel.setFieldValue(
                                    'FT_TIPOCOMBUSTIVEL',
                                    filteredFuels.find(fuel => {
                                        return e.value === fuel.label;
                                    })?.value || '',
                                );
                            }}
                            onSelect={async e => {
                                setValueFuel(e.value.label);
                                formikCombustivel.setFieldValue('FT_TIPOCOMBUSTIVEL', e.value.value);
                                console.log("Combustivel selecionado: ", e.value);

                                const credorId = formikCombustivel.values.CREDOR;
                                if (credorId) {
                                    const valor = await getValorCombustivel(credorId, e.value.value);
                                    setValueValorCombustivel(valor);
                                    formikCombustivel.setFieldValue('VALORCOMBSUTIVEL', valor);
                                }
                            }}
                            suggestions={filteredFuels}
                            completeMethod={searchFuels}
                            dropdown
                            placeholder='Tipo de Combustível...'
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    formikCombustivel.touched.FT_TIPOCOMBUSTIVEL && formikCombustivel.errors.FT_TIPOCOMBUSTIVEL,
                                'popup-form-inactive': !(
                                    formikCombustivel.touched.FT_TIPOCOMBUSTIVEL && formikCombustivel.errors.FT_TIPOCOMBUSTIVEL
                                ),
                            })}>
                            {formikCombustivel.errors.FT_TIPOCOMBUSTIVEL}
                        </div>
                    </div>
                    <div className='p-field p-col-12 p-md-2'>
                        <label htmlFor='descricao'>Valor</label>
                        <InputNumber
                            id='valorCombustivel'
                            value={valueValorCombustivel}
                            onChange={e => {
                                setValueValorCombustivel(e.value);
                                formikCombustivel.setFieldValue('VALORCOMBSUTIVEL', e.value);
                            }}
                            mode='currency'
                            currency='BRL'
                            locale='pt-BR'
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    formikCombustivel.touched.VALORCOMBSUTIVEL && formikCombustivel.errors.VALORCOMBSUTIVEL,
                                'popup-form-inactive': !(
                                    formikCombustivel.touched.VALORCOMBSUTIVEL && formikCombustivel.errors.VALORCOMBSUTIVEL
                                ),
                            })}>
                            {formikCombustivel.errors.VALORCOMBSUTIVEL}
                        </div>
                    </div>
                    <div className='p-field p-col-12 p-md-2'>
                        <label htmlFor='descricao'>Quantidade</label>
                        <InputNumber
                            id='quantidadeCombustivel'
                            value={valueQuantidadeCombustivel}
                            onChange={e => {
                                setValueQuantidadeCombustivel(e.value);
                                formikCombustivel.setFieldValue('QUANTIDADECOMBSUTIVEL', e.value);
                            }}
                            mode="decimal" // Corrigido para aceitar casas decimais
                            locale="pt-BR"
                            minFractionDigits={2} // Define o mínimo de casas decimais
                            maxFractionDigits={2}
                        />
                        <div
                            className={classNames('p-invalid popup-fade', {
                                'popup-form-active':
                                    formikCombustivel.touched.QUANTIDADECOMBSUTIVEL && formikCombustivel.errors.QUANTIDADECOMBSUTIVEL,
                                'popup-form-inactive': !(
                                    formikCombustivel.touched.QUANTIDADECOMBSUTIVEL && formikCombustivel.errors.QUANTIDADECOMBSUTIVEL
                                ),
                            })}>
                            {formikCombustivel.errors.QUANTIDADECOMBSUTIVEL}
                        </div>
                    </div>
                </div>
                <div className='p-fluid p-grid p-justify-between'>
                    <div className='p-col-12 p-md-4'>
                        <Button
                            type='button'
                            label='Liberar abastecimento'
                            onClick={() => {
                                console.log("cliquei")
                                formikCombustivel.handleSubmit();
                                setRegisterFinished(true);
                            }}
                        />
                    </div>

                    {response?.request.status === 200 ? (
                        <div className='p-col-12 p-md-5'>
                            <Button
                                icon='pi pi-plus'
                                type='button'
                                className='p-button-success'
                                label='Cadastrar novo'
                                onClick={() => {
                                    //formikCombustivel.resetForm();
                                    formikCombustivel.setFieldValue('ID','');
                                    formikCombustivel.setFieldValue('QUANTIDADECOMBSUTIVEL',0);
                                    setValueQuantidadeCombustivel(0);
                                    formikCombustivel.setFieldValue('VALORCOMBSUTIVEL',0);
                                    setValueValorCombustivel(0);
                                    formikCombustivel.setFieldValue('FT_VEICULO','');
                                    setSelectedVeiculo(null);
                                    formikCombustivel.setFieldValue('FT_MOTORISTA','');
                                    setSelectedMotorista(null);
                                    formikCombustivel.setFieldValue('FT_TIPOCOMBUSTIVEL','');
                                    setValueFuel('');

                                    setRegisterFinished(false);
                                }}
                            />
                        </div>
                    ) : (
                        <></>
                    )}

                </div>
            </div>
        </div>
    );
}


export default AbastecimentoForm;